export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8256.90f7f260.jpg";